import { isUndefined, omitBy } from "lodash";

/**
 * If `object` is undefined, returns undefined. Otherwise, set the object's fields to the values
 * in `update` if they are defined.
 */
export const updateIfDefined = <T extends Record<string, unknown>>(
  object: T | undefined,
  update: Partial<T>
): T | undefined =>
  object === undefined
    ? undefined
    : {
        ...object,
        ...omitBy(update, isUndefined),
      };

/**
 * If `object` is undefined, returns undefined. Otherwise, set the object's fields to the values
 * in `update`. If `update` has fields that are present, but have the value `undefined`, the object
 * will get the value `undefined` for those fields.
 */
export const setIfDefined = <T extends Record<string, unknown>>(
  object: T | undefined,
  update: Partial<T>
): T | undefined =>
  object === undefined
    ? undefined
    : {
        ...object,
        ...update,
      };
